import { UPSAPIProvider, UPSProvider, UPSSessionProvider } from "@app/provider";
import React, { ReactNode } from "react";

interface UPSContextWrapperProps {
  children: ReactNode;
}

export const UPSContextWrapper: React.FC<UPSContextWrapperProps> = ({
  children,
}) => {
  return (
    <UPSSessionProvider>
      <UPSProvider>
        <UPSAPIProvider>{children}</UPSAPIProvider>
      </UPSProvider>
    </UPSSessionProvider>
  );
};
